(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('tickets', {
      parent: 'app',
      url: '/tickets',
      views: {
        'content@': {
          templateUrl: 'components/tickets/tickets.html',
          controller: 'TicketsController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    });
  }
})();
